import { resolveRedirectLocation } from '@/wabunka-src/common/utils/url/urlRedirect';

/**
 * クライアント遷移でも server middleware（`server/middleware/urlRedirect.ts`）と同じ正規化をかける。
 *
 * 直接アクセスは server middleware が SSR の前に 301 するのでここでは何も起きない。
 * 残っているのは、内部リンクや楽天アフィリエイトの `url=` パラメータのように
 * SPA 遷移でなし形・旧URLへ入ってくる経路。
 */
export default defineNuxtRouteMiddleware((to) => {
  const location = resolveRedirectLocation(to.fullPath);
  if (!location) {
    return;
  }

  return navigateTo(location, { redirectCode: 301, external: /^https?:\/\//.test(location) });
});
